import React from "react";
import { connect } from "react-redux";
import MenuGroup from "./MenuGroup";

import { checkPermissions } from "../../system/utils/UserPermissions";

const SideBarMenu = (props) => {
  return (
    <div>
      <div className='menu-group-item pl-3'>
        <div className='menu-group'>
          <ul className='sub-links'>
            <li>
              <a href='/dashboard' style={{ fontSize: 13.6, fontWeight: 400 }}>
                Dashboard
              </a>
            </li>
          </ul>
        </div>
      </div>

      {checkPermissions(props.permissions, ["ALL"]) && (
        <MenuGroup title='Admin Users'>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/admin-users'>View Admin Users</a>
              </li>
              {checkPermissions(props.permissions, [
                "ALL",
                "ADD_ADMIN_USER",
              ]) && (
                <li>
                  <a href='/admin-users/create'>Add Admin User</a>
                </li>
              )}
            </ul>
          </div>
        </MenuGroup>
      )}

      {checkPermissions(props.permissions, ["ALL", "VIEW_USERS"]) && (
        <MenuGroup title='Users'>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/users'>View Users</a>
              </li>
              {checkPermissions(props.permissions, ["ALL", "ADD_USER"]) && (
                <li>
                  <a href='/users/create'>Add User</a>
                </li>
              )}
            </ul>
          </div>
        </MenuGroup>
      )}

      {checkPermissions(props.permissions, ["ALL", "VIEW_BOOKINGS"]) && (
        <MenuGroup title='Bookings'>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/bookings'>View Bookings</a>
              </li>
            </ul>
          </div>
        </MenuGroup>
      )}

      {checkPermissions(props.permissions, [
        "ALL",
        "VIEW_DEALS",
        "VIEW_EXCURSIONS",
      ]) && (
        <MenuGroup title='Deals & Excursions'>
          <div className='menu-group'>
            <ul className='sub-links'>
              {checkPermissions(props.permissions, ["ALL", "VIEW_DEALS"]) && (
                <li>
                  <a href='/deals'>View Deals</a>
                </li>
              )}
              {checkPermissions(props.permissions, [
                "ALL",
                "VIEW_EXCURSIONS",
              ]) && (
                <li>
                  <a href={"/excursions"}>View Excursions</a>
                </li>
              )}
              {checkPermissions(props.permissions, ["ALL", "ADD_DEALS"]) && (
                <li>
                  <a href='/deals/create'>Add Deal</a>
                </li>
              )}
              {checkPermissions(props.permissions, [
                "ALL",
                "ADD_EXCURSIONS",
              ]) && (
                <li>
                  <a href='/excursions/create'>Add Excursion</a>
                </li>
              )}
            </ul>
          </div>
        </MenuGroup>
      )}
      {checkPermissions(props.permissions, ["ALL", "VIEW_ENQUIRIES"]) && (
        <MenuGroup title='Enquiries'>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/enquiries/callbacks'>View Callbacks</a>
              </li>
              <li>
                <a href='/enquiries/holiday-enquiries'>
                  View Holiday Enquiries
                </a>
              </li>
              <li>
                <a href={"/enquiries/itinerary-builder"}>
                  View Itinerary Enquiries
                </a>
              </li>
              <li>
                <a href={"/enquiries/deal-enquiry"}>View Deal Enquiries</a>
              </li>
            </ul>
          </div>
        </MenuGroup>
      )}
      {checkPermissions(props.permissions, ["ALL", "VIEW_PAYMENTS"]) && (
        <MenuGroup title='Payments'>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/payment/'>View Payments</a>
              </li>
            </ul>
          </div>
        </MenuGroup>
      )}

      {checkPermissions(props.permissions, ["ALL", "VIEW_BLOGS"]) && (
        <MenuGroup title={"Blogs"}>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/blogs'>View Blogs</a>
              </li>
              <li>
                <a href='/blogs/create'>Add Blog</a>
              </li>
            </ul>
          </div>
        </MenuGroup>
      )}

      {checkPermissions(props.permissions, ["ALL"]) && (
        <MenuGroup title='Setup'>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/pages'>View Pages</a>
              </li>
              <li>
                <a href='/referrers'>View Referees</a>
              </li>
              <li>
                <a href='/banners'>View Banners</a>
              </li>
              <li>
                <a href='/countries'>View Countries</a>
              </li>
              <li>
                <a href='/cities'>View Cities</a>
              </li>
              <li>
                <a href='/destination-categories'>View Categories</a>
              </li>
              <li>
                <a href='/sub-categories'>View Sub Categories</a>
              </li>
              <li>
                <a href='/cruise-lines'>View Cruise Lines</a>
              </li>
              <li>
                <a href='/cruiseline-page'>View Cruise Line Page Details</a>
              </li>
              <li>
                <a href='/ships'>View Ships</a>
              </li>
              <li>
                <a href='/hotels'>View Hotels</a>
              </li>
              <li>
                <a href='/search-tags'>View Search Tags</a>
              </li>
              <li>
                <a href={"/deal-types"}>View Deal Types</a>
              </li>
              <li>
                <a href={"/activity-categories"}>View Activity Categories</a>
              </li>
            </ul>
          </div>
        </MenuGroup>
      )}

      {checkPermissions(props.permissions, ["ALL", "VIEW_SEO"]) && (
        <MenuGroup title={"Seo"}>
          <div className='menu-group'>
            <ul className='sub-links'>
              <li>
                <a href='/seo'>View SEO</a>
              </li>
              <li>
                <a href='/seo/create'>Add SEO</a>
              </li>
            </ul>
          </div>
        </MenuGroup>
      )}
    </div>
  );
};

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
  };
}

export default connect(mapStateToProps)(SideBarMenu);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menu.jsx